import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Gallery from "@/pages/home/components/Gallery";
import Videos from "@/pages/home/components/Videos";
import Timeline from "@/pages/home/components/Timeline";
import HotRank from "@/pages/home/components/HotRank";
import Faq from "@/pages/home/components/Faq";
import Cta from "@/pages/home/components/Cta";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Header />
      <Hero />
      <Gallery />
      <Videos />
      <Timeline />
      <HotRank />
      <Faq />
      <Cta />
      <Footer />
    </main>
  );
}